import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const login = async (loginDetail) => {
  return await apiCall("post", apiEndPoints.LOGIN, loginDetail);
};
const forgotPassword = async (data) => {
  return await apiCall("post", apiEndPoints.FORGOTPASSWORD, data);
};
const otpVerify = async (data) => {
  return await apiCall("post", apiEndPoints.OTPVERIFY, data);
};
const updatePassword = async (data) => {
  return await apiCall("post", apiEndPoints.UPDATEPASSWORD, data);
};
const ChangePassword = async (data) => {
  return await apiCall("post", apiEndPoints.CHANGEPASSWORD, data);
};
const firebaseIdUpdate = async (data) => {
  return await apiCall("post", apiEndPoints.FIREBASE_UPDATE, data);
};

const tokenGenrate = async () => {
  const tkn = await apiCall("get", apiEndPoints.JWTTOKEN);
  if (tkn.data.status == 200) {
    return tkn;
  } else {
    return null;
  }
};

const authService = {
  login,
  forgotPassword,
  otpVerify,
  updatePassword,
  ChangePassword,
  firebaseIdUpdate,
  tokenGenrate,
};

export default authService;
